export default "__VITE_ASSET__0Sn6uxTn__"